module.exports = __webpack_public_path__ + "static/img/Jai-Murray.03a9ad1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jai-Murray.jpg
// module id = g6l+
// module chunks = 0